"use strict";

const getInputsData = (form, columns, wallBase, zontSpacing) => {
    let result = []
    do {
        result.push(calculateRow(+form[`wallHeight-${columns}`].value, +form[`perimeter-${columns}`].value, +form[`corners-${columns}`].value, +form[`tees-${columns}`].value, wallBase, zontSpacing))
        columns -= 1;
    } while(columns > 0)

    return result.reverse()
}

const setResultData = (form, inputsData, columns, wallBase) => {
    const blockHeight = Number(form.blockHeight.value) || 0;
    const walerLength = Number(form.walerLength.value) || 0;
    const woodWaste = 1.15;
    const zevelerSpacing = 8;

    const zonts = form.querySelector("#zonts");
    const zotes = form.querySelector("#zotes");
    const zuckles = form.querySelector("#zuckles");
    const loZotes = form.querySelector("#loZotes");
    const zats = form.querySelector("#zats");
    const zees = form.querySelector("#zees");
    const zevelers = form.querySelector("#zevelers");
    const walers = form.querySelector("#walers");
    
    const zontsValue = inputsData.reduce((acc, item) => acc + item.zonts, 0);
    const zucklesValue = inputsData.reduce((acc, item) => acc + item.zuckles, 0);
    const zatsValue = inputsData.reduce((acc, item) => acc + item.strongbacks, 0);
    const zeesValue = inputsData.reduce((acc, item) => acc + Math.floor(item.wallHeight * 12 / blockHeight) * 2 * item.tees, 0);
    const zevelersValue = inputsData.reduce((acc, item) => acc + (wallBase === 1 ? 0 : item.perimeter), 0)
    const walersValue = inputsData.reduce((acc, item) => acc + item.perimeter * item.zontLevels * woodWaste / walerLength, 0);

    zonts && (zonts.innerText = Math.ceil(zontsValue / 20) * 20);
    zotes && (zotes.innerText = Math.ceil(zontsValue / 20));
    zuckles && (zuckles.innerText = Math.ceil(zucklesValue / 10) * 10);
    loZotes && (loZotes.innerText = Math.ceil(zucklesValue / 10));
    zats && (zats.innerText = zatsValue);
    zees && (zees.innerText = zeesValue);
    zevelers && (zevelers.innerText = Math.floor((zevelersValue / zevelerSpacing * 2)))
    walers && (walers.innerText = Math.floor(Math.round(walersValue)))

    do {
        const strongbacksQty = form.querySelector(`#strongbacksQty-${columns}`);
        const strongbackLgth = form.querySelector(`#strongbackLgth-${columns}`);
        const kickersQty = form.querySelector(`#kickersQty-${columns}`);
        const kickerLgth = form.querySelector(`#kickerLgth-${columns}`);
                                                                                                                                                                                                                                                                                                                                                    
        strongbacksQty && (strongbacksQty.innerText = inputsData[columns-1].strongbacks)
        strongbackLgth && (strongbackLgth.innerText = inputsData[columns-1].strongback)
        kickersQty && (kickersQty.innerText = inputsData[columns-1].kickers)
        kickerLgth && (kickerLgth.innerText = inputsData[columns-1].kicker)

        columns -= 1
    } while (columns > 0)
}

export const calculateBracing = () => {
    const form = document.querySelector("#zontEstimator");
    const wallBase = Number(form.wallBase.value) || 0;
    const wallHeight = form.querySelector("#wallHeightField");
    const columnQty = wallHeight.childElementCount - 1;
    const zontSpacing = 5.5;
    const inputsData = getInputsData(form, columnQty, wallBase, zontSpacing)

    setResultData(form, inputsData, columnQty, wallBase)
}

const addResultColumn = () => {
    const header = document.querySelector("#headerResultRow");
    const strongbacksQty = document.querySelector("#strongbacksQtyResultRow");
    const strongbackLength = document.querySelector("#strongbackLgthResultRow");
    const kickersQty = document.querySelector("#kickersQtyResultRow");
    const kickerLength = document.querySelector("#kickersLgthResultRow");
  
    const headerCell = document.createElement('th');
    const strongbacksCell = document.createElement('td');
    const strongbackCell = document.createElement('td');
    const kickersCell = document.createElement('td');
    const kickerCell = document.createElement('td');
  
    headerCell.innerText = `#${header.childElementCount}`;
    strongbacksCell.id = `strongbacksQty-${strongbacksQty.childElementCount}`;
    strongbackCell.id = `strongbackLgth-${strongbackLength.childElementCount}`;
    kickersCell.id = `kickersQty-${kickersQty.childElementCount}`;
    kickerCell.id = `kickerLgth-${kickerLength.childElementCount}`;
  
    header.appendChild(headerCell);
    strongbacksQty.appendChild(strongbacksCell);
    strongbackLength.appendChild(strongbackCell);
    kickersQty.appendChild(kickersCell);
    kickerLength.appendChild(kickerCell);
}

const addInputColumn = (height, perimeter, corners, tees) => {
    const inputHeight = document.createElement('input');
    const inputPerimeter = document.createElement('input');
    const inputCorners = document.createElement('input');
    const inputTees = document.createElement('input');
  
    inputHeight.id = `wallHeight-${height.childElementCount}`;
    inputPerimeter.id = `perimeter-${perimeter.childElementCount}`;
    inputCorners.id = `corners-${corners.childElementCount}`;
    inputTees.id = `tees-${tees.childElementCount}`;
    inputHeight.type = "number";
    inputPerimeter.type = "number";
    inputCorners.type = "number";
    inputTees.type = "number";
  
    inputHeight.classList.add("calc-ft-input", "input-width", "me-2");
    inputPerimeter.classList.add("calc-ft-input", "input-width", "me-2");
    inputCorners.classList.add("calc-ft-input", "input-width", "me-2");
    inputTees.classList.add("calc-ft-input", "input-width", "me-2");
  
    height.appendChild(inputHeight);
    perimeter.appendChild(inputPerimeter);
    corners.appendChild(inputCorners);
    tees.appendChild(inputTees);
  
    addResultColumn();
}

export const bracingOnChange = () => {
    const form = document.querySelector("#zontEstimator");

    if (form) {
        const addHeight = document.querySelector("#addHeight");
        const wallHeight = document.querySelector("#wallHeightField");
        const perimeter = document.querySelector("#perimeterField");
        const corners = document.querySelector("#cornersField");
        const tees = document.querySelector("#teesField");

        addHeight && (addHeight.onclick = () => wallHeight.childElementCount < 5 && addInputColumn(wallHeight, perimeter, corners, tees));
    }
}

const calculateRow = (wallHeight, perimeter, corners, tees, wallBase, zontSpacing) => {
    const result = {
        strongbacks: 0,
        kickers: 0,
        strongback: 0,
        kicker: 0,
        tees: tees,
        perimeter: perimeter,
        wallHeight: wallHeight
    }

    if (wallBase === 0) { // Prepoured
        switch (true) { 
            case wallHeight > 16:
                alert('Contact Fab-Form to discuss height of pour (888)303-3278');
                break;
            case wallHeight > 12 && wallHeight <= 16:
                result.zontLevels = 4;
                break;
            case wallHeight > 8 && wallHeight <= 12:
                result.zontLevels = 3;
                break;
            case wallHeight > 4 && wallHeight <= 8:
                result.zontLevels = 2;
                break;
            case wallHeight > 0 && wallHeight <= 4:
                result.zontLevels = 0;
                break;
        }
    } else if (wallBase === 1) { // Monopour
        switch (true) {
            case wallHeight > 12:
                alert('Contact Fab-Form to discuss height of your monopour (888)303-3278');
                break;
            case wallHeight >7 && wallHeight <= 12:
                result.zontLevels = 3;
                break;
            case wallHeight > 0 && wallHeight <= 7:
                result.zontLevels = 2;
                break;
        }
    } else { alert('Please select either Monopour or Prepoured base.')}
    
    result.zuckles = Math.round(perimeter / zontSpacing) + corners;

    // Estimating Zats, Strongback and Kicker quantities
    if (wallBase === 0 && wallHeight < 4.75) {
        result.kickers = result.zuckles;
    } else {
        result.strongbacks = result.zuckles;
        result.kickers = result.zuckles;
    }

    result.strongback = Math.ceil(wallHeight / 2) * 2 || 0;
    result.kicker = Math.floor((Math.sqrt(2) * wallHeight + 1) / 2) * 2 || 0;
    result.zonts = (corners + Math.round(perimeter / zontSpacing)) * result.zontLevels;
    
    return result
}